import { withTranslation } from "react-i18next";

import React from 'react';
import { Footer } from '../Common/Footer';
import { DashboardHeader } from '../Common/DashboardHeader';
import ProductsUpload from '../../Models/ProductsUpload';
import { connect } from 'react-redux';
import { productUpload } from '../../Action/productUpload';
import { withRouter } from 'react-router';
import CKEditor from 'ckeditor4-react';
import SimpleReactValidator from 'simple-react-validator';
import axios from 'axios';
import { post } from 'axios';
import Files from 'react-files';
import { Header } from '../Common';
import ImageUploader from 'react-images-upload';
import Products from '../../Models/Products';

import Resizer from 'react-image-file-resizer';
import Common from "../../Models/Common";

class ProductUploadConfirmationEdit extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert(this.props.t('9'))
            this.props.history.push('/login/seller');
        };

        this.state = {

            services: [
                {
                    serviceName: '',
                    price: '',
                }
            ],

            file: '', imagePreviewUrl: '',

            files: [],

            _id: 1,
            firstTitle: '',
            secondTitle: '',
            description: '',
            servicePrice: '',
            expectedDelivary: '',
            delivaryFormat: '',
            numberOfOrders: '',
            acceptance: '',
            paidForService: '',
            affiliatorPromote: '',
            categories: [],
            subCategories: [],
            affiliatorCommission: [],
            subCategory: '',
            Category: '',
            // affCommission: '',
            affCommission: React.createRef(),
            includeTransaction: '',
            includeVat: '',
            selectedFile: null,
            picture: null,
            img: null,
            file: null,
            file2: null,
            file3: null,
            file4: null,
            pictures: [],
            editor_msg: '',
            message: '',
            subCategoryName: '',
            products: [],
            flag: '',
            counter: '',
            singleImg: '',
            singleImage: '',
            singleImagePicture: '',
            selfaff: '',
            autoPayment: '',
        };
        // console.log(this.props.location.state)

        // console.log(this.props.location.state.singleImage)
        // this.state.files[0]='';
        this.getCategories();
        this.getAffiliatorCommission();
        SimpleReactValidator.addLocale('klingon', {
            integer: `${this.props.t('10')}`,
            max: `:attribute :max ${this.props.t('5')} .`,
            required: ` :attribute ${this.props.t('62')}`,
            min: `:attribute :min ${this.props.t('6')}`,
        });
        this.validator = new SimpleReactValidator({
            locale: 'klingon',
        })
    }
    componentDidMount() {
        window.scrollTo(0, 0)

        ProductsUpload.getCategoryName(this.props.location.state.subCategory).then(res => {
            this.setState({ subCategoryName: res.data.payload.cat_name })
        })
        this.getPrice()
        this.setState({
            id: this.props.location.state.id,
            firstTitle: this.props.location.state.firstTitle,
            file: this.props.location.state.file,
            pictures: this.props.location.state.picture,
            counter: this.props.location.state.picture.length,
            secondTitle: this.props.location.state.secondTitle,
            sellerId: this.props.location.state.seller_id,
            servicePrice: this.props.location.state.servicePrice,
            expectedDelivary: this.props.location.state.expectedDelivary,
            autoPayment: this.props.location.state.autoPayment,
            singleImg: this.props.location.state.singleImg,
            singleImage: this.props.location.state.singleImage,

            singleImagePicture: this.props.location.state.singleImagePicture,
            delivaryFormat: this.props.location.state.delivaryFormat,
            numberOfOrders: this.props.location.state.numberOfOrders,

            subCategory: this.props.location.state.subCategory,
            Category: this.props.location.state.Category,
            affCommission: this.props.location.state.affCommission,
            includeVat: this.props.location.state.includeVat,
            paidForService: this.props.location.state.paidForService,
            affiliatorPromote: this.props.location.state.affiliatorPromote,
            editor_msg: this.props.location.state.editor_msg,
            IsDraft: this.props.location.state.IsDraft,
            acceptance: this.props.location.state.acceptance,
            selfaff: this.props.location.state.selfaff,
        })

    }
    // handleChange() {
    //     ProductsUpload.getSubCategory(e.target.value).then(res => {
    //         this.setState({
    //             subCategories: res.data.category_sub
    //         })
    //     })
    // }
    onEditorChange(evt) {
        this.setState({
            editor_msg: evt.editor.getData()
        });
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    checkValue(a) {
        this.validator.showMessageFor(a)
        let data = {
            'name': this.state.firstTitle,
            'product_id': this.props.location.state.id
        }
        ProductsUpload.getTitle(data).then(res => {
            if (res.data.flag === 1) {
                alert(this.props.t('0'))
                this.state.firstTitle = ''
            } else {
                this.state.firstTitle = this.state.firstTitle
            }
        })
    }
    getCategories() {
        ProductsUpload.getCategoryDropdown().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }
    handleChange(e) {
        ProductsUpload.getSubCategory(e.target.value).then(res => {
            this.setState({
                subCategories: res.data.category_sub
            })
        })
    }
    getAffiliatorCommission() {
        ProductsUpload.getCategory().then(res => {
            this.setState({ affiliatorCommission: res.data.aff_points })
        })
    }
    updateChange(e) {
        this.setState({
            delivaryFormat: e.target.value,
        })
    }
    updateChange1(e) {
        this.setState({
            acceptance: e.target.value
        })
    }
    handleIsDraft() {
        this.setState({ IsDraft: 0 })
    }
    handlePublish() {
        this.setState({ IsDraft: 1 })
    }
    // onChange(e) {
    //     let reader = new FileReader();
    //     let picture=this.state.picture;
    //     let file = e.target.files[0];
    //     reader.onloadend = () => {
    //         this.setState({
    //             file: file,
    //             picture:'',
    //             img:'',
    //             imagePreviewUrl: reader.result
    //         })
    //     }
    //     reader.readAsDataURL(file)
    // }
    onChange(e) {
        let reader = new FileReader();
        let file = e.target.files[0];
        let fileSize = e.target.files[0].size / 1024 / 1024;
        var pictures = this.state.pictures;
        reader.onloadend = () => {
            if (fileSize <= 3) {
                pictures.push({
                    id: pictures.length,
                    file: file,
                    picture: '',
                    img: '',
                    imagePreviewUrl: reader.result
                });
            } else {
                alert(this.props.t('88')+ ' 20KB～3MB '+this.props.t('20'))
            }
            this.setState({
                pictures,
                counter: this.state.counter + 1
            })

        }
        reader.readAsDataURL(file)
    }

    onChange1(e) {
        let file = e.target.files[0];
        if (file != '' || file != undefined || file != null) {
            let fileSize = e.target.files[0].size / 1024 / 1024;
            let reader = new FileReader();
            if (fileSize <= 3) {
                reader.onloadend = () => {
                    this.setState({
                        file: file,
                        singleImagePicture: '',
                        singleImg: '',
                        singleImage: '',
                        imagePreviewUrl: reader.result
                    })
                }
                reader.readAsDataURL(file)
            } else {
                this.setState({
                    file: '',
                    singleImagePicture: '',
                    singleImg: this.props.location.state.singleImg,
                    singleImage: this.props.location.state.singleImage,
                })
                alert(this.props.t('88')+' 20KB～3MB '+this.props.t('20'))
            }
        }
    }

    updateChange(e) {
        this.setState({
            affCommission: e.target.value,
        })
    }
    updateChangeDelivary(e) {
        this.setState({
            delivaryFormat: e.target.value,
        })
    }

    // addMore() {
    //     this.setState(preState =>
    //         ({
    //             services: [...preState.services, {
    //                 serviceName: '',
    //                 price: ''
    //             }]
    //         })
    //     );
    // }

    // createUI() {
    //     return this.state.services.map((el, i) => (
    //         <div key={i} className="mt-2">
    //             <input placeholder="" name="serviceName" className="basic_input" value={el.serviceName || ''} onChange={this.handleChange.bind(this, i)} />
    //             <input type="number" placeholder="" name="price" className="basic_input ml-2" style={{ width: '10%' }} value={el.price || ''} onChange={this.handleChange.bind(this, i)} /> {this.props.t('138')}
    //             <button className="btn btn-sm btn-danger ml-2" onClick={this.removeClick.bind(this, i)} >remove</button>
    //         </div>
    //     ))
    // }

    // handleChange(i, e) {
    //     const { name, value } = e.target;
    //     let services = [...this.state.services];
    //     services[i] = { ...services[i], [name]: value };
    //     this.setState({ services });
    // }

    // removeClick(i) {
    //     let services = [...this.state.services];
    //     services.splice(i, 1);
    //     this.setState({ services });
    // }

    getPrice() {
        if (this.state.products.commission_in_ex_vat === 'EXCLUDE_VAT') {
            this.setState({ servicePrice: this.props.location.state.products.price_ex, includeVat: false })
        } else if (this.state.products.commission_in_ex_vat === 'INCLUDE_VAT') {
            this.setState({ servicePrice: this.props.location.state.products.price_inc, includeVat: true })
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        if (this.validator.allValid()) {
            var logged_user = JSON.parse(window.localStorage.getItem('info'));
            if (this.state.id === 'undefined' || this.state.id === '' || this.state.id === null) {
                this.setState({ id: '' })
            }

            if (this.state.picture === 'undefined' || this.state.picture === '' || this.state.picture === null) {
                this.setState({ picture: '' })
            }
            if (this.state.singleImg) {
                if (this.state.singleImg === undefined || this.state.singleImg === '' || this.state.singleImg === null) {
                    this.state.singlePictureString = '';
                }
                else {
                    this.state.singlePictureString = this.state.singleImagePicture;
                }
            }
            if (this.state.IsDraft === 0) {
                const formData = new FormData();
                formData.append('id', this.props.location.state.id)
                formData.append('title', this.state.firstTitle)
                formData.append('single_picture', this.state.file)
                formData.append('single_picture_string', this.state.singlePictureString)
                this.state.pictures.map((file) => {
                    // console.log('file');
                    formData.append('file[]', file.file);
                    formData.append('file_string[]', file.image);
                });
                // formData.append('file', this.state.pictures)
                // formData.append('services', JSON.stringify(this.state.services))
                formData.append('short_desc', this.state.secondTitle)
                formData.append('seller_id', this.state.sellerId)
                formData.append('price_int', this.state.servicePrice)
                formData.append('expected_delivery_days', this.state.expectedDelivary)
                formData.append('delivery_format', this.state.delivaryFormat)
                formData.append('no_of_order_at_atime', this.state.numberOfOrders)
                formData.append('sub_category_id', this.refs.subCategory.value)
                formData.append('category_id', this.refs.Category.value)
                formData.append('affiliator_commission', this.refs.affCommission.value)
                formData.append('commission_in_ex_vat', this.state.includeVat)
                // formData.append('paidForService', this.state.paidForService)
                // formData.append('is_to_be_affiliated', this.state.affiliatorPromote)
                formData.append('long_desc', this.state.editor_msg)
                formData.append('is_estimate_or_customizable', this.state.acceptance)
                formData.append('is_draft', this.state.IsDraft)
                formData.append('autoPayment', this.state.autoPayment)
                formData.append('selfaff', this.state.selfaff)
                // console.log(formData)
                // console.log(data)
                axios({
                    method: 'post',
                    // url: 'http://192.168.1.110/sharework_back_v2/public/backend/upload-product',
                    // url: 'http://192.168.43.253/sharework_back_v2/public/backend/upload-product',
                    // url: 'https://sharework-admin.bitpeboot.com/backend/upload-product',
                    url:  Common.api + 'upload-product',
                    data: formData,
                    config: {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                }).then(res => {
                    if (res.data.status === 200) {
                        alert(this.props.t('11'))
                        window.scrollTo(0, 0)
                        this.props.history.push('/service-list');
                    }
                })
                    .catch(
                        console.log('asd')
                    )
            } else {
                console.log(this.state.singleImagePicture)
                this.props.history.push({
                    pathname: `/product-upload-confirm`,
                    state: {
                        id: this.props.location.state.id,
                        firstTitle: this.state.firstTitle,
                        // singleImg: this.state.singleImg,
                        singlePicture: this.state.file ? this.state.file : this.state.singleImg,
                        singleImagePicture: this.state.singleImagePicture,
                        singleImage: this.state.singleImage,
                        picture: this.state.pictures,
                        secondTitle: this.state.secondTitle,
                        seller_id: logged_user.id,
                        servicePrice: this.state.servicePrice,
                        expectedDelivary: this.state.expectedDelivary,
                        img: this.state.img,
                        delivaryFormat: this.state.delivaryFormat,
                        numberOfOrders: this.state.numberOfOrders,

                        subCategory: this.refs.subCategory.value,
                        Category: this.refs.Category.value,
                        affCommission: this.refs.affCommission.value,
                        includeVat: this.state.includeVat,
                        paidForService: this.state.paidForService,
                        affiliatorPromote: this.state.affiliatorPromote,
                        editor_msg: this.state.editor_msg,
                        IsDraft: this.state.IsDraft,
                        acceptance: this.state.acceptance,
                        autoPayment: this.state.autoPayment,
                        selfaff: this.state.selfaff,
                    }
                })
            }
        } else {
            this.validator.showMessages();
        }
    }

    deleteImage(i) {
        let pictures = this.state.pictures;
        const removeIndex = pictures.findIndex(e => e.id === i);
        const filteredPictures = this.state.pictures.filter((e, index) => index !== removeIndex);
        this.setState({ pictures: filteredPictures, counter: this.state.counter - 1 })
    }

    imagePreview(x, image, id, i) {
        // console.log("immgg preview@@@@@@@@:", image);
        // console.log("immgg preview@@@@@@@@xxxxx:", x);
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            if (i < 3) {
                if (image === null || image == undefined) {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '0px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={Common.baseUrl+x} />
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '0px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={image} />
                            </div>
                        </div>
                    )
                }
            } else if (i >= 3 && i <= 5) {
                if (image === null || image == undefined) {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={x} />
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={image} />
                            </div>
                        </div>
                    )
                }
            } else if (i >= 6 && i <= 8) {
                if (image === null || image == undefined) {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={x} />
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={image} />
                            </div>
                        </div>
                    )
                }
            }
            else if (i >= 9 && i <= 10) {
                if (image === null || image == undefined) {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={x} />
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={image} />
                            </div>
                        </div>
                    )
                }
            }
        } else if (isDesktop) {
            if (i < 5) {
                if (image === null || image == undefined) {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '0px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={Common.baseUrl+x} />
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '0px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={image} />
                            </div>
                        </div>
                    )
                }
            } else if (i >= 5 && i <= 10) {
                if (image === null || image == undefined) {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={x} />
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div>
                            <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                                <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                    <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                                </div>
                                <img src={image} />
                            </div>
                        </div>
                    )
                }
            }
        }
    }

    imgShow() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div className="row multiple_image_upload" style={{ marginLeft: '0px', width: '280px', marginTop: '8px', marginRight: '5px' }}>
                    <div className="imgPreview" style={{ marginTop: '0px' }}>
                        <div className="row multiple_image_upload" style={{ marginLeft: '0px', width: '280px', marginRight: '5px' }}>
                            {this.state.pictures.map((p, i) =>
                                this.imagePreview(p.img, p.imagePreviewUrl, p.id, i)
                            )}
                        </div>
                    </div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                    <div className="" style={{ marginTop: '10px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                    <div className="" style={{ marginTop: '10px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                    <div className="" style={{ marginTop: '10px' }}></div>
                </div>
            )
        } else if (isDesktop) {
            return (
                <div className="row multiple_image_upload" style={{ marginLeft: '0px', width: '450px', marginTop: '8px', marginRight: '5px' }}>
                    <div className="imgPreview" style={{ marginTop: '0px' }}>
                        <div className="row multiple_image_upload" style={{ marginLeft: '0px', width: '450px', marginRight: '5px' }}>
                            {this.state.pictures.map((p, i) =>
                                this.imagePreview(p.img, p.imagePreviewUrl, p.id, i)
                            )}
                        </div>
                    </div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                    <div className="" style={{ marginTop: '10px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                </div>
            )
        }
    }

    image() {
        const isMobile = window.innerWidth <= 500;
        if (isMobile) {
            if (this.state.counter < 10) {
                return (
                    <input type="file" className="" onChange={this.onChange.bind(this)} style={{ width: "55%", marginLeft: '0px', border: '1px solid #cccccc' }} />
                )
            } else {
                return (
                    <div></div>
                )
            }
        } else {
            if (this.state.counter < 10) {
                return (
                    <input type="file" className="" onChange={this.onChange.bind(this)} />
                )
            } else {
                return (
                    <div></div>
                )
            }
        }
    }

    singleImage() {
        let { imagePreviewUrl } = this.state;
        // console.log("imagePreviewUrl~~~~~ ", imagePreviewUrl);
        if ((this.props.location.state.singleImg === null && this.props.location.state.singleImage === null) || (this.props.location.state.singleImg === undefined && this.props.location.state.singleImage === undefined)) {

            return (
                <div className="">
                    <div className="imgPreview">
                        <img src={imagePreviewUrl} />
                    </div>
                </div>

            )
        } else if (this.props.location.state.singleImg) {
            let reader = new FileReader();
            let singlePicture = this.props.location.state.singleImg;
            reader.onloadend = () => {
                this.setState({
                    singlePicture: singlePicture,
                    imagePreviewUrl2: reader.result
                })
            }
            reader.readAsDataURL(singlePicture)
            let { imagePreviewUrl2 } = this.state;
            // console.log("imagePreviewUrl~~~~~ 222", imagePreviewUrl2);
            return (
                <div className="">
                    <div className="imgPreview">
                        <img src={imagePreviewUrl2} height='100px' width='100' />
                    </div>
                </div>
            )

            // return (
            //     <div className="">
            //         <div className="imgPreview">
            //             <img src={this.props.location.state.singleImg} height='100px' width='100' />
            //         </div>
            //     </div>
            // )
        } else if (this.props.location.state.singleImage) {
            // console.log("~!~~~~~~~~ props: ", this.props.location.state.singleImage);
            return (
                <div className="">
                    <div className="imgPreview">
                        <img src={Common.baseUrl+this.props.location.state.singleImage} height='100px' width='100' />
                    </div>
                </div>
            )
        } else {
            return (
                <div className="">
                    <div className="imgPreview">
                        <img src={imagePreviewUrl} />
                    </div>
                </div>

            )
        }
    }

    title() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile view
        if (isMobile) {
            if (this.state.flag === 1) {
                return (
                    <div>
                        <input type="text" className="basic_input input_width_height1 p-2" value={this.state.firstTitle} onChange={this.updateValue.bind(this, 'firstTitle')} onBlur={this.checkValue.bind(this, 'firstTitle')} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('71'), this.state.firstTitle, 'required|min:10|max:25')}</span>
                    </div>
                )
            } else {
                return (
                    <div>
                        <input type="text" className="basic_input input_width_height1 p-2" value={this.state.firstTitle} onChange={this.updateValue.bind(this, 'firstTitle')} onBlur={this.checkValue.bind(this, 'firstTitle')} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('71'), this.state.firstTitle, 'required|min:10|max:25')}</span>
                    </div>
                )
            }
        }
        // for desktop view
        else if (isDesktop) {
            if (this.state.flag === 1) {
                return (
                    <div>
                        <input type="text" className="basic_input input_width_height1 p-2" value={this.state.firstTitle} onChange={this.updateValue.bind(this, 'firstTitle')} onBlur={this.checkValue.bind(this, 'firstTitle')} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('71'), this.state.firstTitle, 'required|min:10|max:25')}</span>
                    </div>
                )
            } else {
                return (
                    <div>
                        <input type="text" className="basic_input input_width_height1 p-2" value={this.state.firstTitle} onChange={this.updateValue.bind(this, 'firstTitle')} onBlur={this.checkValue.bind(this, 'firstTitle')} /><br />
                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('71'), this.state.firstTitle, 'required|min:10|max:25')}</span>
                    </div>
                )
            }
        }
    }


    render() {
        let { imagePreviewUrl } = this.state;
        let $imagePreview = null;
        if (imagePreviewUrl) {
            $imagePreview = (<img src={imagePreviewUrl} />)
        } else {
            $imagePreview = (<div className="previewText"> Image</div>)
        }
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;

        //for mobile view
        if (isMobile) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid main">
                        <div className="mt-5 mb-3 input_name big_font guide_text" style={{ fontSize: '20px' }}>
                            {this.props.t('12')}
                                </div>
                        <form onSubmit={this.handleSubmit.bind(this)}>
                            <div className="row form-group">
                                <div className="col-md-1"></div>
                                <div className="col-md-10">
                                    <div className="childs">
                                        <div className=" ">
                                            <h2>{this.state.message}</h2>
                                        </div>
                                        <div style={{ display: "none" }}>
                                            <div className="field_text_width" style={{ width: '100%' }}>
                                                <span></span><img src={require("../../assets/images/bullet.png")} width="15 " height="auto" alt="" />
                                                <span className="common_text_bold" >{this.props.t('63')}</span><br />
                                                <span className="mandatory_alert font_12" >* {this.props.t('100')}</span>
                                            </div>
                                            <div className="field_width">
                                                <select className="cat_drop catagory_select" ref="Category" onChange={this.handleChange.bind(this)} value={this.state.Category}>
                                                    <option value=""> {this.props.t('22')}</option>
                                                    {this.state.categories.map(rp =>
                                                        <option value={rp.id} key={rp.id} >
                                                            {rp.cat_name}
                                                        </option>
                                                    )}
                                                </select>
                                                <select className="cat_drop catagory_select ml-2" ref="subCategory" value={this.state.subCategory} >
                                                    <option value={this.state.subCategory}>{this.state.subCategoryName}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div>&nbsp;</div>
                                        <div style={{ width: "100%" }}>
                                            <span><img src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" alt="" /></span>
                                            <span className="common_text_bold">{this.props.t('23')}</span><br />
                                            <span className="mandatory_alert font_12">* {this.props.t('100')} </span> <span className="font_12">(10~25{this.props.t('90')})</span><br />
                                        </div>
                                        <div className="">
                                            {this.title()}
                                        </div>
                                        <div>&nbsp;</div>
                                        <div style={{ width: "100%" }}>
                                            <span className="common_text_bold">{this.props.t('36')}</span><br />
                                            <span className="mandatory_alert font_12">* {this.props.t('100')}</span> <span className="font_12">(15~30{this.props.t('90')})</span><br />
                                        </div>
                                        <div className="">
                                            <input type="text" className="catch_copy_input p-2" value={this.state.secondTitle} onChange={this.updateValue.bind(this, 'secondTitle')} onBlur={() => this.validator.showMessageFor('secondTitle')} /><br />
                                            <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message(this.props.t('36'), this.state.secondTitle, 'required|secondTitle|min:15|max:30')}</span>
                                        </div>
                                        <div>&nbsp;</div>
                                        <div className="field_text_width" style={{ width: "100%" }}>
                                            <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                            <span className="common_text_bold" style={{ width: "100%" }} >{this.props.t('50')}</span><br />
                                            <span className="mandatory_alert font_12">* {this.props.t('100')}</span> <span className="font_12">(1~5000{this.props.t('90')})</span>
                                        </div>
                                        <div className="field_width">
                                            <CKEditor
                                                data={this.state.editor_msg}
                                                onChange={this.onEditorChange.bind(this)}
                                                onBlur={() => this.validator.showMessageFor('editor_msg')}
                                                config={{
                                                    removePlugins: [
                                                        ['link']
                                                    ]
                                                }}
                                            />
                                            {this.validator.message(this.props.t('50'), this.state.editor_msg, 'required|editor_msg|min:1|max:5000')}
                                        </div>
                                    </div>
                                    <div className="" style={{ paddingLeft: '4%' }}>
                                        <div className="">
                                            <div className="field_text_width" style={{ width: "100%" }}>
                                                <span className="common_text_bold">{this.props.t('7')} </span><br />
                                                <span className="mandatory_alert font_12">* {this.props.t('100')}</span><br />
                                                <span className="mandatory_alert font_12">* {this.props.t('88')} 20KB{this.props.t('136')}3MB {this.props.t('20')}</span><br />
                                                <span className="mandatory_alert font_12">* {this.props.t('64')} JPEG, JPG, PNG, GIF {this.props.t('105')}</span><br />
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width" style={{ height: '104px' }}>
                                                <input type="file" className="" onChange={this.onChange1.bind(this)} style={{ width: "55%", marginBottom: '7px', marginLeft: '0px', border: '1px solid #cccccc', marginBottom: '7px' }} />
                                                {this.singleImage()}
                                            </div>
                                            <div>&nbsp;</div>
                                        </div>
                                        <div className="">
                                            <div className="field_text_width" style={{ width: '100%' }}>
                                                <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                <span className="common_text_bold">{this.props.t('106')} </span><br />
                                                <span className="mandatory_alert" style={{ fontSize: "12px" }}>* {this.props.t('100')}</span><br />
                                                <span className="mandatory_alert font_12">* {this.props.t('88')} 20KB{this.props.t('136')}3MB {this.props.t('20')}</span><br />
                                                <span className="mandatory_alert font_12">* {this.props.t('64')} JPEG, JPG, PNG, GIF {this.props.t('105')}</span><br />
                                                <span className="mandatory_alert font_12">* {this.props.t('109')}10{this.props.t('1')}</span><br />
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width" style={{ height: 'auto' }}>
                                                {this.image()}
                                                {this.imgShow($imagePreview)}
                                            </div>
                                            <div>&nbsp;</div>
                                        </div>
                                        <div>&nbsp;</div>
                                        <div>
                                            <div className="field_text_width" style={{ width: "100%" }}>
                                                <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                <span className="common_text_bold">{this.props.t('52')}</span><br />
                                                <span className="mandatory_alert" style={{ fontSize: '12px' }}>* {this.props.t('100')}</span>
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width">
                                                <div className="row" style={{ marginLeft: '0px', marginRight: '0px', height: '39px' }}>
                                                    <div className="" style={{ height: '39px' }}>
                                                        <input type="number" className="basic_input input_width_height2 p-2" style={{ width: '100%' }} value={this.state.servicePrice} onChange={this.updateValue.bind(this, 'servicePrice')} onBlur={() => this.validator.showMessageFor('servicePrice')}></input>
                                                    </div>
                                                    &nbsp;<span className="my-auto">{this.props.t('138')}</span>&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <div style={{ marginTop: '12px' }}>
                                                        <input type="checkbox" checked={this.state.autoPayment} onChange={this.updateValue.bind(this, 'autoPayment')} />&nbsp;&nbsp;
                                                    </div>
                                                    <div class="my-auto">
                                                        {this.props.t('75')}
                                                    </div>
                                                    <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('52'), this.state.servicePrice, 'required|servicePrice|integer')}</span>
                                                </div>
                                            </div>
                                            <span className="field_width">(20%{this.props.t('14')})</span>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div style={{ height: 'auto' }}>
                                            <div className="field_text_width" style={{ width: "100%" }}>
                                                <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                <span className="common_text_bold">{this.props.t('15')}</span><br />
                                                {/* <span className="mandatory_alert">* Required</span> */}
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width" style={{ width: "100%" }}>
                                                <div className="row" style={{ marginLeft: '0px', marginRight: '0px', height: '30px' }}>
                                                    <div className="" style={{ height: '30px' }}>
                                                        <select className="cat_drop catagory_select mr-2" style={{ width: '100%' }} ref='affCommission' onBlur={() => this.validator.showMessageFor('affCommission')} value={this.state.affCommission} onChange={this.updateChange.bind(this)} >
                                                            <option value="" >{this.props.t('22')} </option>
                                                            {this.state.affiliatorCommission.map(rp =>
                                                                <option value={rp.id} key={rp.id}>
                                                                    {rp.point_value}
                                                                </option>
                                                            )}
                                                        </select>
                                                    </div> &nbsp;&nbsp;
                                                    <span className="my-auto">%</span> &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <div style={{ marginTop: '9px' }}>
                                                        <input type="checkbox" checked={this.state.selfaff} onChange={this.updateValue.bind(this, 'selfaff')} />&nbsp;&nbsp;
                                                    </div>
                                                    <div class="my-auto">
                                                        {this.props.t('54')}
                                                    </div>

                                                    <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('15'), this.state.affCommission, 'required')}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        {/* <div style={{ height: '39px' }}>
                                            <div className="field_text_width">
                                                <span className="common_text_bold">{this.props.t('76')}</span><br />
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width">
                                                <input type="checkbox" checked={this.state.selfaff} onChange={this.updateValue.bind(this, 'selfaff')} />&nbsp;&nbsp;
                                                {this.props.t('111')}
                                                    </div>
                                        </div> */}
                                        <div>
                                            <div className="field_text_width" style={{ width: "100%" }}>
                                                <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                <span className="common_text_bold">{this.props.t('77')}</span><br />
                                                <span className="mandatory_alert">* {this.props.t('100')}</span>
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width">

                                                <select className="cat_drop catagory_select" onChange={this.updateChange.bind(this)} value={this.state.delivaryFormat} onBlur={() => this.validator.showMessageFor('delivaryFormat')}>
                                                    <option value="">{this.props.t('22')}</option>
                                                    <option value={this.props.t('113')}>{this.props.t('113')}</option>
                                                    <option value="PDF">PDF</option>
                                                    <option value={this.props.t('115')}>{this.props.t('115')}</option>
                                                    <option value={this.props.t('78')}>{this.props.t('78')}</option>
                                                </select>

                                                {/* <input type="text" className="basic_input input_width_height2" value={this.state.delivaryFormat} onChange={this.updateValue.bind(this, 'delivaryFormat')} onBlur={() => this.validator.showMessageFor('delivaryFormat')} /> <br /> */}
                                                <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('77'), this.state.delivaryFormat, 'required|delivaryFormat')}</span>
                                            </div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        <div>
                                            <div className="field_text_width" style={{ width: "100%" }}>
                                                <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                <span className="common_text_bold">{this.props.t('38')}</span><br />
                                                <span className="mandatory_alert" style={{ fontSize: "12px" }}>* {this.props.t('100')}</span>
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width">
                                                <input type="text" className="basic_input input_width_height2 p-2" value={this.state.expectedDelivary} onChange={this.updateValue.bind(this, 'expectedDelivary')} onBlur={() => this.validator.showMessageFor('expectedDelivary')} /> {this.props.t('142')}
                                                {this.validator.message(this.props.t('38'), this.state.expectedDelivary, 'required|expectedDelivary')}
                                            </div>
                                        </div>

                                        <div><div>&nbsp;</div></div>
                                        <div>
                                            <div className="field_text_width" style={{ width: "100%" }}>
                                                <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                <span className="common_text_bold"> {this.props.t('40')}  </span><br />
                                                <span className="mandatory_alert" style={{ fontSize: "12px" }}>* {this.props.t('100')}</span>
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width">
                                                <input type="number" className="basic_input input_width_height2 p-2" value={this.state.numberOfOrders} onChange={this.updateValue.bind(this, 'numberOfOrders')} onBlur={() => this.validator.showMessageFor('numberOfOrders')} />&nbsp;{this.props.t('143')}&nbsp;
                                                <span style={{ color: "red", fontSize: "12px" }}>{this.validator.message(this.props.t('40'), this.state.numberOfOrders, 'required|numberOfOrders|integer')}</span>
                                            </div>
                                        </div>


                                        {/* <tr>
                                                        <td className="field_text_width">
                                                            <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                            <span className="common_text_bold">Add More services Services</span><br />
                                                        </td>
                                                        <td className="width_5"></td>
                                                        <td>{this.createUI()}
                                                            <div>
                                                                <button className="btn btn-sm btn-info mt-2" onClick={this.addMore.bind(this)}>add more</button>
                                                            </div>
                                                        </td>
                                                    </tr> */}
                                        <div><div>&nbsp;</div></div>
                                        <div>
                                            <div className="field_text_width" style={{ width: "100%" }}>
                                                <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                <span className="common_text_bold"> {this.props.t('2')}</span>
                                            </div>
                                            <div className="width_5"></div>
                                            <div className="field_width">
                                                <select className="cat_drop" onChange={this.updateChange1.bind(this)} value={this.state.acceptance} >
                                                    <option value="">{this.props.t('22')} </option>
                                                    <option value="YES">{this.props.t('66')} </option>
                                                    <option value="NO">{this.props.t('42')} </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div><div>&nbsp;</div></div>
                                        {/* <tr>
                                                        <td className="field_text_width">
                                                            <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                            <span className="common_text_bold">Paid for Service</span>
                                                        </td>
                                                        <td className="width_5"></td>
                                                        <td className="field_width">
                                                            <input type="checkbox" name="" value={this.state.paidForService} onChange={this.updateValue.bind(this, 'paidForService')} />  paid for service  <br />
                                                        </td>
                                                    </tr> */}
                                        <div>
                                            <div className="width_5"></div>
                                            <div className="field_width">
                                                <span className="">
                                                    {/* <Link to={'#'}> */}
                                                    <button type="submit" onClick={this.handleIsDraft.bind(this)} className="btn btn-secondary product_upload_buttons" style={{ width: '125px' }}>{this.props.t('55')}</button>
                                                    {/* </Link> */}
                                                </span>
                                                <span className="ml-2">
                                                    <button type="submit" onClick={this.handlePublish.bind(this)} className="btn  product_upload_buttons" style={{ width: '125px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >{this.props.t('81')}</button>
                                                </span>
                                            </div>
                                        </div>
                                        <div>
                                            <div colSpan="3">&nbsp;</div>
                                        </div>
                                        {/* <tr>
                                                <td></td>
                                                <td colSpan="2" >
                                                    <span className="blue_text ml-5"><u>Delete Draft</u></span>
                                                </td>
                                            </tr> */}
                                    </div>
                                    <div>&nbsp;</div>
                                </div>
                                <div className="col-md-1"></div>

                            </div>
                        </form>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div  className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid main">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="mt-5 mb-3 input_name big_font guide_text" style={{ marginLeft: '130px' }}>
                                    {this.props.t('12')}
                                </div>
                                <form onSubmit={this.handleSubmit.bind(this)}>
                                    <div className="row form-group">
                                        <div className="col-md-1"></div>
                                        <div className="col-md-10">
                                            <div className="childs">
                                                <div className=" ">
                                                    <h2>{this.state.message}</h2>
                                                </div>
                                                <div >
                                                    <div className="field_text_width">
                                                        <span></span><img src={require("../../assets/images/bullet.png")} width="15 " height="auto" alt="" />
                                                        <span className="common_text_bold">{this.props.t('63')}</span><br />
                                                        <span className="mandatory_alert font_12" >* {this.props.t('100')}</span>
                                                    </div>
                                                    <div className="field_width">
                                                        <select className="cat_drop" ref="Category" onChange={this.handleChange.bind(this)} value={this.state.Category}>
                                                            <option value=""> {this.props.t('22')}</option>
                                                            {this.state.categories.map(rp =>
                                                                <option value={rp.id} key={rp.id} >
                                                                    {rp.cat_name}
                                                                </option>
                                                            )}
                                                        </select>
                                                        <select className="cat_drop ml-2" ref="subCategory" value={this.state.subCategory} >
                                                            <option value={this.state.subCategory}>{this.state.subCategoryName}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div>&nbsp;</div>
                                                <div>
                                                    <span><img src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" alt="" /></span>
                                                    <span className="common_text_bold">{this.props.t('23')}</span><br />
                                                    <span className="mandatory_alert font_12">* {this.props.t('100')} </span> <span className="font_12">(10~25{this.props.t('90')})</span><br />
                                                </div>
                                                <div className="">
                                                    {this.title()}
                                                </div>
                                                <div>&nbsp;</div>
                                                <div>
                                                    <span className="common_text_bold">{this.props.t('36')}</span><br />
                                                    <span className="mandatory_alert font_12">* {this.props.t('100')}</span> <span className="font_12">(15~30{this.props.t('90')})</span><br />
                                                </div>
                                                <div className="">
                                                    <input type="text" className="catch_copy_input p-2" value={this.state.secondTitle} onChange={this.updateValue.bind(this, 'secondTitle')} onBlur={() => this.validator.showMessageFor('secondTitle')} /><br />
                                                    <span style={{ color: 'red', fontSize: "12px" }}>{this.validator.message(this.props.t('36'), this.state.secondTitle, 'required|min:15|max:30')}</span>
                                                </div>
                                                <div>&nbsp;</div>
                                                <div className="field_text_width">
                                                    <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                    <span className="common_text_bold" >{this.props.t('50')}</span><br />
                                                    <span className="mandatory_alert font_12">* {this.props.t('100')}</span> <span className="font_12">(1~5000{this.props.t('90')})</span>
                                                </div>
                                                <div className="field_width">
                                                    <CKEditor
                                                        data={this.state.editor_msg}
                                                        onChange={this.onEditorChange.bind(this)}
                                                        onBlur={() => this.validator.showMessageFor('editor_msg')}
                                                    />
                                                    {this.validator.message(this.props.t('50'), this.state.editor_msg, 'required|min:1|max:5000')}
                                                </div>
                                            </div>
                                            <div className="" style={{ paddingLeft: '4%' }}>
                                                <table>
                                                    <tbody>
                                                        <tr className="">
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">{this.props.t('7')} </span><br />
                                                                <span className="mandatory_alert font_12">* {this.props.t('100')}</span><br />
                                                                <span className="mandatory_alert font_12">* {this.props.t('88')} 20KB{this.props.t('136')}3MB {this.props.t('20')}</span><br />
                                                                <span className="mandatory_alert font_12">* {this.props.t('64')} JPEG, JPG, PNG, GIF {this.props.t('105')}</span><br />
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width" style={{ height: '104px' }}>
                                                                <input type="file" className="mb-2" onChange={this.onChange1.bind(this)} />
                                                                {this.singleImage()}
                                                            </td>
                                                            <div>&nbsp;</div>
                                                        </tr>
                                                        <tr className="">
                                                            <td className="field_text_width">
                                                                <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                                <span className="common_text_bold">{this.props.t('106')} </span><br />
                                                                <span className="mandatory_alert" style={{ fontSize: "12px" }}>* {this.props.t('100')}</span><br />
                                                                <span className="mandatory_alert font_12">* {this.props.t('88')} 20KB{this.props.t('136')}3MB {this.props.t('20')}</span><br />
                                                                <span className="mandatory_alert font_12">* {this.props.t('64')} JPEG, JPG, PNG, GIF {this.props.t('105')}</span><br />
                                                                <span className="mandatory_alert font_12">* {this.props.t('109')}10{this.props.t('1')}</span><br />
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width" style={{ height: '104px' }}>
                                                                {this.image()}
                                                                {/* <input type="file" className="" onChange={this.onChange.bind(this)} /> */}
                                                                {this.imgShow($imagePreview)}
                                                                {/* <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('Image', this.state.file, 'required|Image')}</span> */}
                                                            </td>
                                                            <div>&nbsp;</div>
                                                        </tr>
                                                        <div>&nbsp;</div>
                                                        <tr>
                                                            <td className="field_text_width">
                                                                <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                                <span className="common_text_bold">{this.props.t('52')}</span><br />
                                                                <span className="mandatory_alert" style={{ fontSize: '12px' }}>* {this.props.t('100')}</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width" style={{ verticalAlign: 'middle' }}>
                                                                <input type="number" className="basic_input input_width_height2 p-2" value={this.state.servicePrice} onChange={this.updateValue.bind(this, 'servicePrice')} onBlur={() => this.validator.showMessageFor('servicePrice')}></input>
                                                                &nbsp;<span>{this.props.t('138')}  (20%{this.props.t('14')})</span>
                                                                &nbsp;&nbsp;&nbsp;&nbsp;
                                                                <input type="checkbox" checked={this.state.autoPayment} onChange={this.updateValue.bind(this, 'autoPayment')} />&nbsp;&nbsp;
                                                                    {this.props.t('75')}
                                                                <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('52'), this.state.servicePrice, 'required|integer')}</span>
                                                            </td>
                                                        </tr>
                                                        <tr><td>&nbsp;</td></tr>
                                                        <tr style={{ height: '39px' }}>
                                                            <td className="field_text_width">
                                                                <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                                <span className="common_text_bold">{this.props.t('15')}</span><br />
                                                                {/* <span className="mandatory_alert">* Required</span> */}
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <select className="cat_drop mr-2" ref='affCommission' onBlur={() => this.validator.showMessageFor('affCommission')} value={this.state.affCommission} onChange={this.updateChange.bind(this)} >
                                                                    <option value="" >{this.props.t('22')} </option>
                                                                    {this.state.affiliatorCommission.map(rp =>
                                                                        <option value={rp.id} key={rp.id}>
                                                                            {rp.point_value}
                                                                        </option>
                                                                    )}
                                                                </select>
                                                                %
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                <input type="checkbox" checked={this.state.selfaff} onChange={this.updateValue.bind(this, 'selfaff')} />&nbsp;&nbsp;
                                                                    {this.props.t('54')}

                                                    <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('15'), this.state.affCommission, 'required')}</span>
                                                        </td>
                                                        </tr>
                                                        <tr><td>&nbsp;</td></tr>
                                                        {/* <tr style={{ height: '39px' }}>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">{this.props.t('76')}</span><br />
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <input type="checkbox" checked={this.state.selfaff} onChange={this.updateValue.bind(this, 'selfaff')} />&nbsp;&nbsp;
                                                                {this.props.t('111')}
                                                        </td>
                                                        </tr> */}
                                                        <tr>
                                                            <td className="field_text_width">
                                                                <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                                <span className="common_text_bold">{this.props.t('77')}</span><br />
                                                                <span className="mandatory_alert">* {this.props.t('100')}</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">

                                                                <select className="cat_drop" onChange={this.updateChangeDelivary.bind(this)} value={this.state.delivaryFormat} onBlur={() => this.validator.showMessageFor('delivaryFormat')}>
                                                                    <option value="">{this.props.t('22')}</option>
                                                                    <option value="video">{this.props.t('113')}</option>
                                                                    <option value="pdf">PDF</option>
                                                                    <option value="audio">{this.props.t('115')}</option>
                                                                    <option value="chat">{this.props.t('78')}</option>
                                                                </select>

                                                                {/* <input type="text" className="basic_input input_width_height2" value={this.state.delivaryFormat} onChange={this.updateValue.bind(this, 'delivaryFormat')} onBlur={() => this.validator.showMessageFor('delivaryFormat')} /> <br /> */}
                                                                <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('77'), this.state.delivaryFormat, 'required')}</span>
                                                            </td>
                                                        </tr>
                                                        <tr><td>&nbsp;</td></tr>
                                                        <tr>
                                                            <td className="field_text_width">
                                                                <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                                <span className="common_text_bold">{this.props.t('38')}</span><br />
                                                                <span className="mandatory_alert" style={{ fontSize: "12px" }}>* {this.props.t('100')}</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <input type="text" className="basic_input input_width_height2 p-2" value={this.state.expectedDelivary} onChange={this.updateValue.bind(this, 'expectedDelivary')} onBlur={() => this.validator.showMessageFor('expectedDelivary')} /> {this.props.t('142')}
                                                                    {this.validator.message(this.props.t('38'), this.state.expectedDelivary, 'required')}
                                                            </td>
                                                        </tr>

                                                        <tr><td>&nbsp;</td></tr>
                                                        <tr>
                                                            <td className="field_text_width">
                                                                <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                                <span className="common_text_bold"> {this.props.t('40')}  </span><br />
                                                                <span className="mandatory_alert" style={{ fontSize: "12px" }}>* {this.props.t('100')}</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <input type="number" className="basic_input input_width_height2 p-2" value={this.state.numberOfOrders} onChange={this.updateValue.bind(this, 'numberOfOrders')} onBlur={() => this.validator.showMessageFor('numberOfOrders')} />&nbsp;{this.props.t('143')}&nbsp;
                                                                <span style={{ color: "red", fontSize: "12px" }}>{this.validator.message(this.props.t('40'), this.state.numberOfOrders, 'required|integer')}</span>
                                                            </td>
                                                        </tr>


                                                        {/* <tr>
                                                            <td className="field_text_width">
                                                                <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                                <span className="common_text_bold">Add More services Services</span><br />
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td>{this.createUI()}
                                                                <div>
                                                                    <button className="btn btn-sm btn-info mt-2" onClick={this.addMore.bind(this)}>add more</button>
                                                                </div>
                                                            </td>
                                                        </tr> */}
                                                        <tr><td>&nbsp;</td></tr>
                                                        <tr>
                                                            <td className="field_text_width">
                                                                <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                                <span className="common_text_bold"> {this.props.t('2')}</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <select className="cat_drop" onChange={this.updateChange1.bind(this)} value={this.state.acceptance} >
                                                                    <option value="">{this.props.t('22')} </option>
                                                                    <option value="YES">{this.props.t('66')} </option>
                                                                    <option value="NO">{this.props.t('42')} </option>
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <tr><td>&nbsp;</td></tr>
                                                        {/* <tr>
                                                            <td className="field_text_width">
                                                                <span></span><img alt="" src={require("../../assets/images/bullet.png")} width="15 ! important" height="auto" />
                                                                <span className="common_text_bold">Paid for Service</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <input type="checkbox" name="" value={this.state.paidForService} onChange={this.updateValue.bind(this, 'paidForService')} />  paid for service  <br />
                                                            </td>
                                                        </tr> */}

                                                        <tr><td>&nbsp;</td></tr>
                                                        <tr>
                                                            <td></td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <span className="mr-5">
                                                                    {/* <Link to={'#'}> */}
                                                                    <button type="submit" onClick={this.handleIsDraft.bind(this)} className="btn btn-secondary product_upload_buttons" style={{ width: '125px' }}>{this.props.t('55')}</button>
                                                                    {/* </Link> */}
                                                                </span>
                                                                <span className="ml-5">
                                                                    <button type="submit" onClick={this.handlePublish.bind(this)} className="btn  product_upload_buttons" style={{ width: '125px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >{this.props.t('81')}</button>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="3">&nbsp;</td>
                                                        </tr>
                                                        {/* <tr>
                                                                <td></td>
                                                                <td colSpan="2" >
                                                                    <span className="blue_text ml-5"><u>Delete Draft</u></span>
                                                                </td>
                                                            </tr> */}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div>&nbsp;</div>
                                        </div>
                                        <div className="col-md-1"></div>

                                    </div>
                                </form>
                            </div>
                            {/* )} */}
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
const mapStateToProps = (state) => ({
    productUpload: state.productUpload,
    errors: state.errors,
    categories: state.categories,
});

// ProductUploadEdit = connect(mapStateToProps, { productUpload })(withRouter(ProductUpload));

export { ProductUploadConfirmationEdit }


 ProductUploadConfirmationEdit = withTranslation('src_Components_ProductUpload_ProductUploadConfirmationEdit')(ProductUploadConfirmationEdit);
